module.exports = __webpack_public_path__ + "img/vertical_6_5_8017.f4dd5f6b.png";